import { trpc } from '@/data-loaders';

export const useAreaAcl = (areaSlug: string) =>
  trpc.getAreaAcl.useQuery({ areaSlug }, { retry: false });
